import { render, staticRenderFns } from "./mall-edit.vue?vue&type=template&id=8eddd5b4&scoped=true&"
import script from "./mall-edit.vue?vue&type=script&lang=js&"
export * from "./mall-edit.vue?vue&type=script&lang=js&"
import style0 from "./mall-edit.vue?vue&type=style&index=0&id=8eddd5b4&prod&scoped=true&lang=css&"
import style1 from "./mall-edit.vue?vue&type=style&index=1&id=8eddd5b4&prod&lang=scss&scoped=true&"
import style2 from "./mall-edit.vue?vue&type=style&index=2&id=8eddd5b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eddd5b4",
  null
  
)

export default component.exports